import * as Redux from 'redux';
import { ReduxPromiseAction } from '../app/app.types';
import { SimpleResponse } from '../app/app.types';
import { callApi } from '../util/ApiCaller';
import {
  REQUEST_COLLECTION,
  GET_PAYMENT_RECORD_DETAIL,
  RETRY_FAILED_PAYMENT,
  GET_PAYMENT_LIST,
  GET_PAYMENT_DETAILS
} from './Constants';
import {
  PaymentRecordDetailActionTypes,
  PaymentRecordDetailsResponse,
  FailedPaymentRequest
} from './Types';
import { pickAuthOrImpersonationToken } from '../util/token.util';

export const getPaymentDetails: Redux.ActionCreator<
  ReduxPromiseAction<
    PaymentRecordDetailActionTypes, SimpleResponse<PaymentRecordDetailsResponse>
  >
> = (paymentId: number): ReduxPromiseAction<
  PaymentRecordDetailActionTypes, SimpleResponse<PaymentRecordDetailsResponse>
> => ({
  type: GET_PAYMENT_DETAILS,
  payload: callApi(
    process.env.REACT_APP_API + '/payment/' + paymentId,
    true,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pickAuthOrImpersonationToken()
      }
    }
  )
});

export const getPaymentList: Redux.ActionCreator<
  ReduxPromiseAction<
    PaymentRecordDetailActionTypes, SimpleResponse<PaymentRecordDetailsResponse>
  >
> = (): ReduxPromiseAction<
  PaymentRecordDetailActionTypes, SimpleResponse<PaymentRecordDetailsResponse>
> => ({
  type: GET_PAYMENT_LIST,
  payload: callApi(
    process.env.REACT_APP_API + '/payment/list',
    true,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pickAuthOrImpersonationToken()
      }
    }
  )
});

export const getPaymentDetailRecords: Redux.ActionCreator<
  ReduxPromiseAction<
    PaymentRecordDetailActionTypes, SimpleResponse<PaymentRecordDetailsResponse>
  >
> = (year: number, month: number): ReduxPromiseAction<
  PaymentRecordDetailActionTypes, SimpleResponse<PaymentRecordDetailsResponse>
> => ({
  type: GET_PAYMENT_RECORD_DETAIL,
  payload: callApi(
    process.env.REACT_APP_API + '/payment/record/' + year + '/' + month,
    true,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pickAuthOrImpersonationToken()
      }
    }
  )
});

export const requestCollection: Redux.ActionCreator<
  ReduxPromiseAction<
    PaymentRecordDetailActionTypes, SimpleResponse<PaymentRecordDetailsResponse>
  >
> = (paymentHistoryId: number): ReduxPromiseAction<
  PaymentRecordDetailActionTypes, SimpleResponse<PaymentRecordDetailsResponse>
> => ({
  type: REQUEST_COLLECTION,
  payload: callApi(
    process.env.REACT_APP_API + '/payment/collection',
    true,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pickAuthOrImpersonationToken()
      },
      body: JSON.stringify({paymentHistoryId})
    }
  )
});

export const retryFailedPayment: Redux.ActionCreator<
  ReduxPromiseAction<
    PaymentRecordDetailActionTypes, SimpleResponse<{msg: string}>
  >
> = (failedPaymentRequest: FailedPaymentRequest): ReduxPromiseAction<
  PaymentRecordDetailActionTypes, SimpleResponse<{msg: string}>
> => ({
  type: RETRY_FAILED_PAYMENT,
  payload: callApi(
    process.env.REACT_APP_API + '/payment/collection/failed',
    true,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pickAuthOrImpersonationToken()
      },
      body: JSON.stringify({
        paymentCode: failedPaymentRequest.paymentCode,
        email: failedPaymentRequest.email,
        cardNumber: failedPaymentRequest.cardNumber,
        cardHolderName: failedPaymentRequest.cardHolderName,
        cvc: failedPaymentRequest.cvc,
        expiryMonth: failedPaymentRequest.expiryMonth,
        expiryYear: failedPaymentRequest.expiryYear,
        country: failedPaymentRequest.country
      })
    }
  )
});



// WEBPACK FOOTER //
// ./src/payments/Actions.tsx